<div class="auth-page">
  <div class="auth-card app-card">

    <div class="auth-brand">
      <span class="material-symbols-outlined brand-icon">key</span>
      <h1 class="brand-title">{{ 'auth.reset_title' | translate }}</h1>
      <p class="brand-sub">{{ 'auth.admin' | translate }}</p>
    </div>

    <div class="error-state" *ngIf="!token">
      <span class="material-symbols-outlined error-icon">error</span>
      <p>{{ 'err.invalid_reset_link' | translate }}</p>
      <a routerLink="/forgot-password" class="auth-btn">{{ 'btn.request_reset' | translate }}</a>
    </div>

    <div class="success-state" *ngIf="done">
      <span class="material-symbols-outlined success-icon">check_circle</span>
      <h3>{{ 'auth.reset_done' | translate }}</h3>
      <p>{{ 'auth.reset_done_sub' | translate }}</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()" class="auth-form" *ngIf="token && !done">

      <div class="form-group">
        <label for="rpNewPw">{{ 'lbl.new_password' | translate }}</label>
        <input
          formControlName="new_password"
          id="rpNewPw"
          type="password"
          class="form-control themed-input"
          placeholder="At least 8 characters"
          autocomplete="new-password"
        />
        <span class="field-error" *ngIf="form.get('new_password')?.invalid && form.get('new_password')?.touched">
          {{ 'err.min8' | translate }}
        </span>
      </div>

      <div class="form-group">
        <label for="rpConfirmPw">{{ 'lbl.confirm_password' | translate }}</label>
        <input
          formControlName="confirm_password"
          id="rpConfirmPw"
          type="password"
          class="form-control themed-input"
          placeholder="Repeat new password"
          autocomplete="new-password"
        />
        <span class="field-error" *ngIf="form.errors?.['mismatch'] && form.get('confirm_password')?.touched">
          {{ 'err.password_mismatch' | translate }}
        </span>
      </div>

      <button type="submit" class="auth-btn" [disabled]="loading">
        <span class="btn-spinner" *ngIf="loading"></span>
        {{ loading ? ('auth.resetting' | translate) : ('btn.set_new_password' | translate) }}
      </button>

    </form>

  </div>
</div>
